module.exports = __webpack_public_path__ + "main/assets/public/player-media-session/playing-384.af6f3f7159003254.jpg";